import { FC } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { CommonRoutesPaths } from '@resume-portal/routes/routes.enum'

export const NewburyBullhornResume: FC = () => {
  const location = useLocation()
  const searchParams = location.search
  return <Navigate to={`${CommonRoutesPaths.BullhornParse}${searchParams}`} />
}
